import React, { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { Card } from "../components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

export default function AuditLogsPage() {
  const [rows, setRows] = useState([]);

  const load = useCallback(async () => {
    try {
      const r = await api.get("/audit-logs");
      setRows(r.data);
    } catch (_) {
      // Non-fatal: the rows count stays at 0 and the table shows empty.
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-6" data-testid="audit-logs-page">
      <div>
        <h1 className="heading text-3xl font-bold text-slate-900">Audit Logs</h1>
        <p className="text-slate-500 mt-1">{rows.length} events</p>
      </div>
      <Card>
        <Table>
          <TableHeader>
            <TableRow className="bg-slate-50">
              <TableHead>Timestamp</TableHead>
              <TableHead>Actor</TableHead>
              <TableHead>Entity</TableHead>
              <TableHead>Action</TableHead>
              <TableHead>Details</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((r, i) => (
              <TableRow key={r.id || `${r.timestamp}-${i}`}>
                <TableCell className="text-xs text-slate-500">{new Date(r.timestamp).toLocaleString()}</TableCell>
                <TableCell className="text-sm">{r.actor_email}</TableCell>
                <TableCell className="text-sm">{r.entity}</TableCell>
                <TableCell className="text-sm">{r.action}</TableCell>
                <TableCell className="text-xs text-slate-500 max-w-md truncate">
                  {r.old_value ? `was: ${typeof r.old_value === "string" ? r.old_value : JSON.stringify(r.old_value)} → ` : ""}
                  {r.new_value ? `${typeof r.new_value === "string" ? r.new_value : JSON.stringify(r.new_value)}` : ""}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
